/**
 * @flow
 * @relayHash e06530b8fd5ae903d5de6822d911575c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BlockAddInput = {
  title: string,
  active: boolean,
  slug: string,
  linkedArticles?: ?$ReadOnlyArray<?BlockAddItemInput>,
  clientMutationId?: ?string,
};
export type BlockAddItemInput = {
  title?: ?string,
  articleId?: ?string,
};
export type BlockAddMutationVariables = {|
  input: BlockAddInput
|};
export type BlockAddMutationResponse = {|
  +BlockAdd: ?{|
    +error: ?string,
    +blockEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type BlockAddMutation = {|
  variables: BlockAddMutationVariables,
  response: BlockAddMutationResponse,
|};
*/


/*
mutation BlockAddMutation(
  $input: BlockAddInput!
) {
  BlockAdd(input: $input) {
    error
    blockEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "BlockAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "BlockAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "BlockAddInput!"
      }
    ],
    "concreteType": "BlockAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blockEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "BlockEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Block",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "BlockAddMutation",
  "id": null,
  "text": "mutation BlockAddMutation(\n  $input: BlockAddInput!\n) {\n  BlockAdd(input: $input) {\n    error\n    blockEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BlockAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "BlockAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '98728f61c6625832695fef84023081ff';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/BlockAddMutation.graphql.js